import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import '../style/organizationDetails.css'


const OrganizationDetails = () => {
    const { id } = useParams();
    const [organizationDetails, setOrganizationDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrganizationDetails = async () => {
            try {
                const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/organization/${id}/details`);
                setOrganizationDetails(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrganizationDetails();
    }, [id]);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }
    if (error) {
        return <div className="error">Error: {error.message}</div>;
    }

    return (
     <div>
        <Header/>
        <Sidebar/>
           <div className="organization-details-container" style={{margin:"90px auto 0 auto"}}>
            
            {organizationDetails && (
                
                <div className="organization-details" >
                    <h2>संस्था विवरण</h2>
                    <p><strong>क्र सं:</strong> {organizationDetails.id}</p>
                    <p><strong>नाम:</strong> {organizationDetails.name}</p>
                    <p><strong>Municipal Ward:</strong> {organizationDetails.munWard}</p>
                    <p><strong>Municipal Tole:</strong> {organizationDetails.munTole}</p>
                    <p><strong>फोन:</strong> {organizationDetails.phone}</p>
                    <p><strong>इमेल:</strong> {organizationDetails.email}</p>
                    <p><strong>संस्था प्रकार:</strong> {organizationDetails.orgType}</p>
                    <p><strong>संस्थाको Category:</strong> {organizationDetails.orgCategory}</p>
                    <p><strong>सँस्थाप्रमुखको नाम:</strong> {organizationDetails.orgOwner}</p>
                    <p><strong>सँस्थाप्रमुखको इमेल:</strong> {organizationDetails.orgOwnerEmail}</p>
                    <p><strong>सुरुगरेको बर्ष:</strong> {organizationDetails.establishedYear}</p>
                    <p><strong>काम गर्नेको संख्या:</strong> {organizationDetails.employeeNo}</p>
                    <p><strong>Latitude:</strong> {organizationDetails.latitude}</p>
                    <p><strong>Longitude:</strong> {organizationDetails.longitude}</p>
                    <p><strong>Organization Owner Designate:</strong>{organizationDetails.orgOwnerDesignate}</p>
                    <p><strong>Remarks:</strong> {organizationDetails.remarks}</p>
                </div>
            )}
        </div>
     </div>
    );
};

export default OrganizationDetails;
